import TourMediaList from './TourMediaList';
import TourMediaDetail from './TourMediaDetail';
import { ReactComponent as Icon } from '../icons/main_menu/marketing_suite.svg';

const tourMedia = {
    List: TourMediaList,
    Detail: TourMediaDetail,
    Icon: Icon,
};

export default tourMedia;

